import React, { useState, useEffect } from 'react'
import { Card, CardBody } from "reactstrap"
import { Spin, message } from 'antd'
import NextBoxDiaryDetailsTable from './NextBoxDiaryDetailsTable'
import { getNextBoxDiaryDetails } from '../../../services/api/apiNextBoxDiary'
import { Link } from 'react-router-dom'
import moment from 'moment'

function NextBoxDiaryDetailsPage(props) {
    const { id } = { ...props }
    const [loading, setLoading] = useState(false)
    const [page, _setPage] = useState(1)
    const [limit, _setLimit] = useState(50)
    const [error, setError] = useState('')
    const [date, setDate] = useState('')
    const [listData, setListData] = useState([])
    const [selectedAll, setSelectedAll] = useState(false)
    const [listSelecteds, setListSelecteds] = useState([])
    const [openAction, setOpenAction] = useState(false)

    const fetchListData = async (id) => {
        setLoading(true)
        setError('')
        setListSelecteds([])
        setSelectedAll(false)
        try {
            const payload = {
                page: page,
                limit: limit,
            }
            if (date) payload.date = { from: date }
            const { data: res } = await getNextBoxDiaryDetails(id)
            const { success, data, message: mes } = { ...res }
            const { date, diaryBoxes = [] } = { ...data }
            if (!success) {
                throw new Error(mes)
            }
            setListData(diaryBoxes)
            setDate(date)
        } catch (error) {
            setError(error.message)
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    const _handleChangeSelectAll = (isActive = false) => {
        if (isActive) {
            const listSelectedId = listData && listData.length > 0 ? listData.map(item => item.number) : []
            setListSelecteds(listSelectedId)
            setSelectedAll(true)
        } else {
            setListSelecteds([])
            setSelectedAll(false)
        }
    }

    const _handleSelected = (number, isAdded) => {
        if (isAdded) {
            if (!listSelecteds.includes(number)) {
                setListSelecteds([
                    ...listSelecteds, number,
                ])
                setSelectedAll(listSelecteds.length + 1 === listData.length)
            }
        } else {
            const filtered = listSelecteds.filter(item => item !== number)

            setListSelecteds(filtered)
            setSelectedAll(false)
        }
    }

    const toggleAction = () => {
        setOpenAction(!openAction)
    }

    useEffect(() => {
        if (id) {
            fetchListData(id)
        }
    }, [id])

    return (
        <div className='NextBoxDiaryDetailsPage'>
            <div className="BackWrapper mb-2">
                <Link to='/next-boxes-diary'><i className='fa fa-chevron-left mr-1' />Nhật ký đóng thùng</Link>
            </div>
            <Card>
                <div className="CardHeader card-header header-elements-inline" style={{ background: '#f5faf4', borderBottom: '1px solid rgba(0, 0, 0, 0.125)' }}>
                    <div className="header-elements d-flex justify-content-between align-items-center w-100">
                        <h1 className='card-title font-weight-bold'>
                            <i className='fa fa-calendar mr-1'></i>
                            {date ? moment(date).format('DD/MM/YYYY') : ''}
                        </h1>
                    </div>
                </div>

                <CardBody>
                    <div className="NextBoxDiaryFilters mb-3 pt-3 pl-3 pr-3"></div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className='d-flex'>
                            {error && <div className="text-danger mx-3">{error}</div>}
                        </div>
                        <div className='d-flex align-items-center'>
                            {/* <div className='d-flex align-items-center mr-3'>
                                <div>Hiển thị</div>
                                <Input
                                    type='select'
                                    value={limit}
                                    name='limit'
                                    onChange={handleChangeLimit}
                                    className='ml-1 mr-1 w-auto'>
                                    {
                                        LIMIT.map(item => {
                                            return <option key={item.value} value={item.value}>{item.name}</option>
                                        })
                                    }
                                </Input>
                            </div>
                            <div>
                                Tổng số <strong>{total}</strong> boxes
                            </div> */}
                        </div>
                    </div>
                    <Spin spinning={loading} tip={'Đang lấy dữ liệu...'} size='large'>
                        <NextBoxDiaryDetailsTable
                            loading={loading}
                            listData={listData}
                            selectedAll={selectedAll}
                            listSelecteds={listSelecteds}
                            handleChangeSelectAll={_handleChangeSelectAll}
                            handleSelected={_handleSelected}
                            detailsId={id}
                            currentDate={date}
                            reset={fetchListData}
                            openAction={openAction}
                            toggleAction={toggleAction}
                        />

                    </Spin>
                </CardBody>
            </Card>
        </div>
    )
}

export default NextBoxDiaryDetailsPage